import { FC, ReactElement, useCallback } from "react";

import Modal, {
  CheckoutSubscriptionModalCloseBtn,
} from "web/Pages/Checkout/Subscription/Modal/modal";

import __ from "web/Layout/Translations";

import WarningIcon from "web/assets/icons/warning.svg";

import { ModalActionTypes } from "web/hooks/useModal/useModalTypes";

import {
  ISubscriptionItemCurrentUserSubscription,
  ISubscriptionTotals,
} from "web/types/Subscription";

import { useAppContext } from "web/context/app";

import ActivityItem, { ActivityItemProps } from "../activityItem";
import ItemFormToFill from "./ItemFormToFill";
import classes from "./formFillerItem.scss";

interface IFormFillerActivityItemItemProps extends ActivityItemProps {
  benefitsWithFormsToUpdate: ISubscriptionItemCurrentUserSubscription[];
  totals: ISubscriptionTotals;
}

const FormFillerItem: FC<IFormFillerActivityItemItemProps> = ({
  benefitsWithFormsToUpdate,
  totals,
  ...restProps
}) => {
  const { modal } = useAppContext();
  const { dispatch } = modal;

  const onSetModalHandler = useCallback(
    (content: ReactElement) => {
      dispatch({ type: ModalActionTypes.ADD_MODAL, modal: content });
    },
    [dispatch]
  );

  const onCloseModalHandler = useCallback(() => {
    dispatch({ type: ModalActionTypes.RESET });
  }, [dispatch]);

  const description = (
    <div className={classes.warning}>
      <WarningIcon className={classes.warning__sign} />
      <span className={classes.warning__info}>
        {__(`
              Uzupełnij swoje dane dotyczące abonamentów, 
              które wybrałeś oraz wpisz adres e-mail osób dla których wybrałeś abonament.
            `)}
      </span>
    </div>
  );

  const onOpenModalHandler = useCallback(() => {
    onSetModalHandler(
      <Modal
        title={__("Zmieniły się wymagania w formularzach")}
        description={description}
        additionalChildren={
          <CheckoutSubscriptionModalCloseBtn onClick={onCloseModalHandler}>
            {__("Zamknij")}
          </CheckoutSubscriptionModalCloseBtn>
        }
        classes={{ content: classes.modalContent }}
      >
        {benefitsWithFormsToUpdate.map((item) => {
          return (
            <ItemFormToFill
              item={item}
              totals={totals}
              handleToggleEditModal={onOpenModalHandler}
            />
          );
        })}
      </Modal>
    );
  }, [onCloseModalHandler, onSetModalHandler, benefitsWithFormsToUpdate]);

  return (
    <ActivityItem {...restProps} onClick={onOpenModalHandler}>
      {__("Uzupełnij dane")}
    </ActivityItem>
  );
};

export default FormFillerItem;
